import React, { useMemo } from 'react';
import styles from './index.module.scss';
import TextItem from './TextItem';
import { Link } from 'react-router-dom';
import Icon from '@/components/Icon';
import Input from './Input';
import { getSocialMedias } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export enum SocialMedia {
  Facebook = 'facebook',
  Tiktok = 'tiktok',
  Instagram = 'instagram',
  X = 'x',
  Whatsapp = 'whatsapp',
}

export const SocialMediaIconMap = {
  [SocialMedia.Facebook]: 'facebook-line',
  [SocialMedia.Tiktok]: 'tiktok-line',
  [SocialMedia.Instagram]: 'instagram-line',
  [SocialMedia.X]: 'x-line',
  [SocialMedia.Whatsapp]: 'whatsapp-line',
};

export const Footer: React.FC = () => {
  const { data = [] } = useQuery([getSocialMedias.name], () =>
    getSocialMedias({ page: 1, page_size: 9999 }).then((res) =>
      res.data?.list?.sort((first, next) => next.weights! - first.weights!),
    ),
  );

  const socialMedias = useMemo(
    () =>
      data.map((item) => ({
        ...item,
        iconName: SocialMediaIconMap[item.icon as SocialMedia] ?? item.icon,
      })),
    [data],
  );

  // const location = useLocation();
  return (
    <footer className={styles.footer}>
      <TextItem title="ABOUT OUR STORE">
        <div className={styles.text}>
          Nonasea ACG is a one-stop shop that caters to and promotes anime
          figures, statues, and accessories related to the anime culture.
        </div>
        <div className={styles.text}>
          <div>@2025 NonASea Limited. All rights reserved.</div>
        </div>
      </TextItem>
      <TextItem title="Info">
        <Link className={styles.link} to="/policy">
          Prvacy policy
        </Link>
        <Link className={styles.link} to="/terms-and-conditions">
          Terms & Conditions
        </Link>
        <Link className={styles.link} to="/about-us">
          About Us
        </Link>
      </TextItem>
      {/* <TextItem title="PRODUCT TYPE">
        <Link className={styles.link} to="/">
          Home
        </Link>
        <Link
          className={styles.link}
          to={`/mall/AllProducts${location.search}`}
        >
          Product
        </Link>
        <Link
          className={styles.link}
          to={`/mall/IchibanKujiOnline${location.search}`}
        >
          IchibanKuji Online
        </Link>
        <Link
          className={styles.link}
          to={`/mall/HexaKujiOnline${location.search}`}
        >
          HexaKuji Online
        </Link>
      </TextItem> */}
      <TextItem title="Let’s keep in touch">
        <div className={styles.icons}>
          {socialMedias.map((item) => (
            <a
              key={item.icon}
              className={styles.icon}
              href={item.url}
              target="_blank"
              rel="noreferrer"
            >
              <Icon id={`#hxicon-${item.iconName}`} />
            </a>
          ))}
          {/* <a
            className={styles.icon}
            href="https://www.facebook.com/profile.php?id=100086428467093"
            target="_blank"
            rel="noreferrer"
          >
            <Icon id="#hxicon-fb" />
          </a>
          <a
            className={styles.icon}
            href="https://www.instagram.com/nonasea_acg/"
            target="_blank"
            rel="noreferrer"
          >
            <Icon id="#hxicon-twitter" />
          </a>
          <a
            className={styles.icon}
            href="https://www.tiktok.com/@nonasea_acg_official"
            target="_blank"
            rel="noreferrer"
          >
            <Icon id="#hxicon-tiktok" />
          </a>
          <a
            className={styles.icon}
            href="https://www.instagram.com/nonasea_acg/"
            target="_blank"
            rel="noreferrer"
          >
            <Icon id="#hxicon-instagram-fill" />
          </a> */}
        </div>
        <Input />
      </TextItem>
    </footer>
  );
};
